<ng-container *ngFor="let activityDate of recentActivity; index as index">
  <div [hidden]="recentActivityDays && index >= recentActivityDays">
    <div class="RecentActivityDateBlock heading-band">
      {{activityDate.Key | khLocalizedDate : dateFormats.KH_SHORTEST}}
    </div>
    <div *ngFor="let mission of activityDate.Missions" class="RecentActivityItemBlock">
      <div>
        <div>
          <div class="label_name">
            {{mission.Name}}
          </div>
          <a *ngIf="mission.MissionId && !isParentView" class="float-right ReportLink" (click)="goToTeacherMissionReport(mission.MissionId)">{{ 'RECENT_ACTIVITY_CONTENT.MISSION_REPORT' | translate }}</a>
          <div *ngIf="mission.MissionId && isParentView" class="float-right text-sm grey">{{ 'RECENT_ACTIVITY_CONTENT.MISSION' | translate }}</div>
          <div class="RecentActivityAttemptsBlock d-flex flex-wrap">
            <div *ngFor="let event of mission.Events" class="d-inline-block">
              <div (click)="viewAttempt(event.AttemptId, event.AttemptItemOrder, hideActions)" [class.QuestionAttemptBoxCorrect]="event.IsCorrect" [class.QuestionAttemptBoxIncorrect]="!event.IsCorrect" class="QuestionAttemptBox animate-show light-bgcolor-NaN" [tooltip]="getMissionEventTooltip(mission.Name, event)">
                {{event.NumberOverride ? event.NumberOverride : event.QuestionNumber }}
              </div>
              <div *ngIf="event.HasSolution" class="live-mode-solution pl-kh-1">
                <fa-icon [icon]="['fas','file']" (click)="viewAttempt(event.AttemptId, event.AttemptItemOrder, hideActions)" class="kh-blue cursor"></fa-icon>
              </div>
            </div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
    <div *ngFor="let skill of activityDate.Skills" class="RecentActivityItemBlock">
      <div class="label_name">
        <span *ngIf="skill.Name" [tooltip]="'RECENT_ACTIVITY_CONTENT.STUDENTS_ARE_ABLE_TO_DO' | translate ">
          {{ 'RECENT_ACTIVITY_CONTENT.ADDITIONAL_PRACTICE' | translate }}
          <fa-icon [icon]="['fas', 'chevron-right']"></fa-icon>
          {{skill.Name}}
        </span>
      </div>
      <div *ngIf="isParentView" class="float-right text-sm grey">{{ 'RECENT_ACTIVITY_CONTENT.PRACTICE' | translate }}</div>
      <div class="RecentActivityAttemptsBlock d-flex flex-wrap">
        <ng-container *ngFor="let event of skill.Events">
          <div *ngIf="skill.Name" (click)="viewAttempt(event.AttemptId, event.AttemptItemOrder, hideActions)" [class.QuestionAttemptBoxCorrect]="event.IsCorrect" [class.QuestionAttemptBoxIncorrect]="!event.IsCorrect" class="QuestionAttemptBox animate-show light-bgcolor-NaN" [tooltip]="getSkillEventTooltip(event)">
            {{event.NumberOverride ? event.NumberOverride : event.ItemOrderInBranch}}
          </div>
        </ng-container>
        <ng-container *ngFor="let event of skill.Events">
          <div *ngIf="!skill.Name" (click)="viewAttempt(event.AttemptId, event.AttemptItemOrder, hideActions)" [class.QuestionAttemptBoxCorrect]="event.IsCorrect" [class.QuestionAttemptBoxIncorrect]="!event.IsCorrect" class="QuestionAttemptBox animate-show light-bgcolor-NaN" [tooltip]="getSkillEventTooltip(event)">
            {{event.NumberOverride ? event.NumberOverride : event.AttemptItemOrder}}
          </div>
        </ng-container>
      </div>
      <div class="clear"></div>
    </div>
    <div *ngFor="let gameShow of activityDate.GameShows" class="RecentActivityItemBlock">
      <div>
        <div>
          <div class="label_name">
            {{gameShow.Name}}
          </div>
          <a *ngIf="gameShow.ActivityId && !isParentView" class="float-right ReportLink" (click)="goToTeacherGameShowReport(gameShow.ActivityId)">
            {{ 'RECENT_ACTIVITY_CONTENT.GAMESHOW_REPORT' | translate }}
          </a>
          <div *ngIf="gameShow.ActivityId && isParentView" class="float-right text-sm grey">{{ 'RECENT_ACTIVITY_CONTENT.GAMESHOW' | translate }}</div>
          <div class="RecentActivityAttemptsBlock d-flex flex-wrap">
            <div *ngFor="let event of gameShow.Events" class="d-inline-block">
              <div (click)="viewAttempt(event.AttemptId, event.AttemptItemOrder, hideActions)" [class.QuestionAttemptBoxCorrect]="event.IsCorrect" [class.QuestionAttemptBoxIncorrect]="!event.IsCorrect" class="QuestionAttemptBox animate-show light-bgcolor-NaN" [tooltip]="getGameShowEventTooltip(gameShow.Name, event)">
                {{event.NumberOverride ? event.NumberOverride : event.AttemptItemOrder}}
              </div>
              <div *ngIf="event.HasSolution" class="live-mode-solution pl-kh-1">
                <fa-icon [icon]="['fas','file']" (click)="viewAttempt(event.AttemptId, event.AttemptItemOrder, hideActions)" class="cursor"></fa-icon>
              </div>
            </div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</ng-container>
<div *ngIf="!recentActivity?.length" class="grey mt-kh-3">
  <i>{{ 'RECENT_ACTIVITY_CONTENT.NONE' | translate }}</i>
</div>
